import { SearchX } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Friendly empty state used for no-results scenarios.
export const EmptyState = ({
  title = 'No homes match your search',
  description = 'Try widening your search by adjusting filters or exploring a different area.',
  actionLabel,
  onAction,
  icon: Icon = SearchX,
}) => (
  <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white py-16 px-6 text-center" data-testid="empty-state">
    <div className="grid h-14 w-14 place-items-center rounded-full bg-sky-50 text-blue-600">
      <Icon size={26} />
    </div>
    <h3 className="mt-4 text-lg font-semibold text-slate-900" data-testid="empty-state-title">{title}</h3>
    <p className="mt-1 max-w-sm text-sm text-slate-600">{description}</p>
    {actionLabel && (
      <Button onClick={onAction} className="mt-4 rounded-full" data-testid="empty-state-action">
        {actionLabel}
      </Button>
    )}
  </div>
);
